// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k3fLJuWz2OHJdsbx8BKe {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  row-gap: 24px;
  column-gap: 20px;
  padding-bottom: 20px;
}
.k3fLJuWz2OHJdsbx8BKe .izVci4pGVZ8RWTZsmEd2 {
  margin-bottom: 6px;
  object-fit: cover;
  width: 100%;
  height: 204px;
}
.k3fLJuWz2OHJdsbx8BKe .lJ_YI_KnKvF1ZLNiZ1km {
  border-radius: 4px;
  border: 1px solid rgba(237, 235, 239, 0.2);
  padding: 8px 8px 12px 8px;
  width: 272px;
  height: 292px;
  position: relative;
  cursor: pointer;
}
.k3fLJuWz2OHJdsbx8BKe .lJ_YI_KnKvF1ZLNiZ1km:hover {
  background-color: #6439df;
  transition: ease-out 0.3s;
}
.k3fLJuWz2OHJdsbx8BKe .lJ_YI_KnKvF1ZLNiZ1km:active {
  background-color: #5b37c0;
  transition: all 0.3s;
}
.k3fLJuWz2OHJdsbx8BKe .lJ_YI_KnKvF1ZLNiZ1km:disabled {
  border: 1px solid rgba(237, 235, 239, 0.5);
  transition: all 0.3s;
}
.k3fLJuWz2OHJdsbx8BKe .BKzTmrIDtie1zdFiudgo {
  display: flex;
  flex-direction: column;
  width: 189px;
  border-radius: 8px;
  border: 1px solid #8d56e8;
  position: absolute;
  height: 70px;
  width: 190px;
  background-color: #2d2d2d;
  padding: 6px 0px;
  top: 140px;
  right: -75px;
  z-index: 10;
}
.k3fLJuWz2OHJdsbx8BKe .BKzTmrIDtie1zdFiudgo .zy6hYJNHjWpyl5kHPqiP {
  font-size: 16px;
  padding: 8px 8px 8px 20px;
}
.k3fLJuWz2OHJdsbx8BKe .BKzTmrIDtie1zdFiudgo .zy6hYJNHjWpyl5kHPqiP:hover {
  background-color: #262626;
  transition: all 0.3s;
}
.k3fLJuWz2OHJdsbx8BKe .BKzTmrIDtie1zdFiudgo .zy6hYJNHjWpyl5kHPqiP:active {
  background-color: #1e1e1e;
  color: #b6b6b6;
  transition: all 0.3s;
}
.k3fLJuWz2OHJdsbx8BKe .BKzTmrIDtie1zdFiudgo .zy6hYJNHjWpyl5kHPqiP:disabled {
  background-color: rgba(50, 50, 50, 0.6);
  color: #636363;
  transition: all 0.3s;
}
.k3fLJuWz2OHJdsbx8BKe .LPvbtT31TLpCg2YgWGvU {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.k3fLJuWz2OHJdsbx8BKe .LPvbtT31TLpCg2YgWGvU .VdAQCfJQ6akPhpHGR9q7 {
  width: 20px;
  padding: 0px;
  background: none;
  border-radius: 0;
}
.k3fLJuWz2OHJdsbx8BKe .LPvbtT31TLpCg2YgWGvU .EU2eUs2BgL8o1UU5LTcr {
  display: flex;
  align-items: center;
  column-gap: 8px;
}
.k3fLJuWz2OHJdsbx8BKe .RZpWiTcA5SJ3LG0q7eWK {
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 8px;
}
.k3fLJuWz2OHJdsbx8BKe .RZpWiTcA5SJ3LG0q7eWK .Je_qheV5g45fAxY6B5fx {
  width: 100%;
  border-radius: 10px;
}
.k3fLJuWz2OHJdsbx8BKe .BiuFJJ4SKeIxsU3U4HjW {
  font-size: 16px !important;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 12px;
  width: 100%;
}
.k3fLJuWz2OHJdsbx8BKe .qIPcmnayBNFFEWqBUrJN {
  font-size: 16px !important;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 4px;
}
.k3fLJuWz2OHJdsbx8BKe .qsiurW1RyrM8xqG5BWZC {
  margin-top: 4px;
  color: rgb(116, 116, 116);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.k3fLJuWz2OHJdsbx8BKe .LSJGqIuaQDDMhzDmHPxy {
  color: #8d56e8;
  font-weight: 500;
}
.k3fLJuWz2OHJdsbx8BKe .fFx9EbF7jY0yvyEv_va4 {
  color: rgb(116, 116, 116);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 14px;
  margin: 0;
}
.k3fLJuWz2OHJdsbx8BKe .MwUOWh8FyPNCWdnFcUQx {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.k3fLJuWz2OHJdsbx8BKe .KvsAm91t5VOiUuHbtkEf {
  color: #8d56e8;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 14px;
  margin: 0;
  line-height: 1.2;
  min-height: 19px; /* Ensure it takes up space even when empty */
  display: block; /* Ensures it maintains the block size */
}
.k3fLJuWz2OHJdsbx8BKe .DIrdSGrizHvPMnOkTX0t {
  color: rgb(116, 116, 116);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 14px;
  margin: 0;
  line-height: 1.2;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/SceneCard/SceneCard.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;AAAF;AAEE;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;AAAJ;AAGE;EACE,kBAAA;EACA,0CAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AADJ;AAGI;EACE,yBCtBO;EDuBP,yBAAA;AADN;AAII;EACE,yBC1BO;ED2BP,oBAAA;AAFN;AAKI;EACE,0CAAA;EACA,oBAAA;AAHN;AAOE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yBCEW;EDDX,gBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AALJ;AAOI;EACE,eAAA;EACA,yBAAA;AALN;AAOM;EACE,yBCjBI;EDkBJ,oBAAA;AALR;AAQM;EACE,yBCnBI;EDoBJ,cC7CQ;ED8CR,oBAAA;AANR;AASM;EACE,uCAAA;EACA,cCtCG;EDuCH,oBAAA;AAPR;AAYE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAVJ;AAYI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAVN;AAaI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAXN;AAeE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAbJ;AAeI;EACE,WAAA;EACA,mBAAA;AAbN;AAiBE;EACE,0BAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAfJ;AAkBE;EACE,0BAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAhBJ;AAmBE;EACE,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAjBJ;AAoBE;EACE,cC9HS;ED+HT,gBAAA;AAlBJ;AAqBE;EACE,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AApBJ;AAuBE;EACE,cClJS;EDmJT,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA,EAAA,6CAAA;EACA,cAAA,EAAA,wCAAA;AArBJ;AAwBE;EACE,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAtBJ","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `k3fLJuWz2OHJdsbx8BKe`,
	"img": `izVci4pGVZ8RWTZsmEd2`,
	"card": `lJ_YI_KnKvF1ZLNiZ1km`,
	"menuBlock": `BKzTmrIDtie1zdFiudgo`,
	"menuItem": `zy6hYJNHjWpyl5kHPqiP`,
	"userBlock": `LPvbtT31TLpCg2YgWGvU`,
	"dropdown": `VdAQCfJQ6akPhpHGR9q7`,
	"userName": `EU2eUs2BgL8o1UU5LTcr`,
	"editButtons": `RZpWiTcA5SJ3LG0q7eWK`,
	"editButton": `Je_qheV5g45fAxY6B5fx`,
	"editInput": `BiuFJJ4SKeIxsU3U4HjW`,
	"title": `qIPcmnayBNFFEWqBUrJN`,
	"date": `qsiurW1RyrM8xqG5BWZC`,
	"username": `LSJGqIuaQDDMhzDmHPxy`,
	"lastModified": `fFx9EbF7jY0yvyEv_va4`,
	"communityInfo": `MwUOWh8FyPNCWdnFcUQx`,
	"usernameDisplay": `KvsAm91t5VOiUuHbtkEf`,
	"timestamp": `DIrdSGrizHvPMnOkTX0t`
};
export default ___CSS_LOADER_EXPORT___;
